import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { LandingService, LandingFormService } from "../shared";

@Component({
  selector: "landing-form",
  templateUrl: "./landing-form.component.html",
  styleUrls: ["./landing-form.component.scss"],
})
export class LandingFormComponent implements OnInit {
  @Input() id: string;
  @Output() onSave: EventEmitter<string> = new EventEmitter();
  @Output() onDuplicate: EventEmitter<string> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public dataService: LandingService,
    public formService: LandingFormService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.form = null;

    if (this.id) {
      this.loading = true;

      this.dataService.getById(this.id).subscribe((item) => {
        this.form = this.formService.getForm(item);
        this.loading = false;
      });
    } else {
      setTimeout(() => {
        this.form = this.formService.getForm();
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/landing-form/landing-form.component.ts